// @flow
import * as React from 'react';

import ConditionalFeature from '~/core/components/conditional-feature';
import type { MenuInsertions } from '~/core/types';
import { MenuItem } from './menu';

const truthyCondition = () => true;

export default function interlaceItems(originalList: Array<React.Element<any>>, insertions: MenuInsertions) {
    return insertions.reduce((interlaced, next, key) => {
        const pos = parseInt(next.position, 10);
        const { element, condition = truthyCondition, enabled } = next;

        const nextItem = (
            <ConditionalFeature condition={condition} key={`${key}-pickerItem`}>
                {() => <MenuItem enabled={enabled}>{element}</MenuItem>}
            </ConditionalFeature>
        );

        if (pos < 0) {
            interlaced.push(nextItem);
        } else {
            interlaced.splice(pos, 0, nextItem);
        }

        return interlaced;
    }, originalList);
}



// WEBPACK FOOTER //
// ./src/components/bulbs/interlace-items.js